import React, { useRef, useState, useCallback, useEffect } from 'react';
import {
  TextField,
  ReferenceField,
  ListBase,
  ListToolbar,
  Pagination,
  FunctionField,
  useRefresh,
  Title,
  useListContext,
  Datagrid,
  ListContextProvider,
} from 'react-admin';

import { Card, Divider, Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';

import { DialogoConfirmacao } from '../../Components';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import { formatCNPJ, SECONDARY_COLOR } from '../../utils';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils/constants';
//import ActionsField from './ActionsField';
import { PERMISSAO_TELA_LOJAS_LISTAR } from '../../utils/dadosTelas';
import DialogoEmpresa from './DialogoEmpresa';
import DialogoShow from './DialogoShow';
import Filter from './Filter';

const useStylesDatagrid = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: SECONDARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const tabs = [
  { id: 'ativos', name: 'Ativos' },
  { id: 'inativos', name: 'Inativos' },
];
//
const MyList = ({ ...props }) => {
  const refDialogoShow = useRef(null);
  const refDialogoCreateEdit = useRef(null);
  const refresh = useRefresh();
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const refDialogoConfirmacao = useRef(null);
  const [ativos, setAtivos] = useState([]);
  const [inativos, setInativos] = useState([]);
  const classes = useStylesDatagrid();

  function handleCriar() {
    if (refDialogoCreateEdit.current) {
      refDialogoCreateEdit.current.handleCreate(1);
    }
  }

  function handleEdit({ id }) {
    if (refDialogoCreateEdit.current) {
      refDialogoCreateEdit.current.handleEdit(id);
    }
  }

  function handleShow({ id }) {
    if (refDialogoShow.current) {
      refDialogoShow.current.handleOpen(id);
    }
  }

  function handleAtivar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Reativação de Loja',
        'Deseja realmente reativar esta Loja?',
        { id, codigo: 1 },
      );
    }
  }

  function handleDesativar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Desativação de Loja',
        'Deseja realmente desativar este Loja?',
        { id, codigo: 2 },
      );
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Exclusão de Loja',
        'Deseja deletar permanentemente este Loja?',
        { id, codigo: 3 },
      );
    }
  }

  async function ativar(id) {
    await api.put(`/empresa-loja/status/ativar/${id}`);
    handleClose();
  }

  async function desativar(id) {
    await api.put(`/empresa-loja/status/inativar/${id}`);
    handleClose();
  }

  async function deletar(id) {
    await api.put(`/empresa-loja/status/deletar/${id}`);
    handleClose();
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        ativar(id);
        break;
      case 2:
        desativar(id);
        break;
      case 3:
        deletar(id);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (ids && ids !== filterValues.status) {
      switch (filterValues.status) {
        case STATUS_ATIVO:
          setAtivos(ids);
          break;
        case STATUS_INATIVO:
          setInativos(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.status]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          {
            ...filterValues,
            status: value === 'ativos' ? STATUS_ATIVO : STATUS_INATIVO,
          },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <Title title="Clientes" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Divider />
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.status === STATUS_ATIVO ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.status === STATUS_ATIVO && (
            <ListContextProvider value={{ ...listContext, ids: ativos }}>
              <Datagrid {...props}>
                <TextField
                  source="id"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <TextField
                  source="nome_fantasia"
                  label="Nome Fantasia"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <TextField
                  source="razao_social"
                  label="Razão Social"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <FunctionField
                  label="CNPJ"
                  render={(record) =>
                    !record.cnpj ? '-' : formatCNPJ(record.cnpj)
                  }
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <ReferenceField
                  source="cidade_id"
                  reference="cidades"
                  label="Cidade"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <TextField
                  source="bairro"
                  label="Bairro"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /*            handleEdit={handleEdit}
                  handleShow={handleShow}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar} */
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  actions={[
                    {
                      key: 'edit',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (record) => handleEdit(record),
                    },
                    {
                      key: 'show',
                      title: 'Detalhes',
                      icon: <VisibilityIcon />,
                      onClick: (record) => handleShow(record),
                    },
                    {
                      key: 'ativar',
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      show: (record) => record.status === STATUS_INATIVO,
                      disabled: (record) => record.id === 1,
                      onClick: (record) => handleAtivar(record),
                    },
                    {
                      key: 'desativar',
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      show: (record) => record.status === STATUS_ATIVO,
                      disabled: (record) => record.id === 1,
                      onClick: (record) => handleDesativar(record),
                    },
                    {
                      key: 'delete',
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      show: (record) => record.status === STATUS_INATIVO,
                      disabled: (record) => record.id === 1,
                      onClick: (record) => handleDeletar(record),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.status === STATUS_INATIVO && (
            <ListContextProvider value={{ ...listContext, ids: inativos }}>
              <Datagrid {...props}>
                <TextField
                  source="id"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <TextField
                  source="nome_fantasia"
                  label="Nome Fantasia"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <TextField
                  source="razao_social"
                  label="Razão Social"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <FunctionField
                  label="CNPJ"
                  render={(record) =>
                    !record.cnpj ? '-' : formatCNPJ(record.cnpj)
                  }
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <ReferenceField
                  source="cidade_id"
                  reference="cidades"
                  label="Cidade"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <TextField source="bairro" label="Bairro" />
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /*                   handleEdit={handleEdit}
                  handleShow={handleShow}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar} */
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  actions={[
                    {
                      key: 'edit',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (record) => handleEdit(record),
                    },
                    {
                      key: 'show',
                      title: 'Detalhes',
                      icon: <VisibilityIcon />,
                      onClick: (record) => handleShow(record),
                    },
                    {
                      key: 'ativar',
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      show: (record) => record.status === STATUS_INATIVO,
                      disabled: (record) => record.id === 1,
                      onClick: (record) => handleAtivar(record),
                    },
                    {
                      key: 'desativar',
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      show: (record) => record.status === STATUS_ATIVO,
                      disabled: (record) => record.id === 1,
                      onClick: (record) => handleDesativar(record),
                    },
                    {
                      key: 'delete',
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      show: (record) => record.status === STATUS_INATIVO,
                      disabled: (record) => record.id === 1,
                      onClick: (record) => handleDeletar(record),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoEmpresa ref={refDialogoCreateEdit} handleClose={handleClose} />
      <DialogoShow ref={refDialogoShow} />
      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_LOJAS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Lojas"
      filterDefaultValues={{ status: STATUS_ATIVO }}
      component="div"
    />
  </ProtegerPagina>
);

export default List;
